import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivateFn } from '@angular/router';
import { Auth } from '../services/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(Auth);
  const router = inject(Router);

  if (authService.authState().isLoggedIn) {
    return true;
  }

  // Store the attempted URL for redirecting after login
  router.navigate(['/']);

  return false;
};